/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { sanctioningBodyApi } from './SanctioningBodyApi';
import { SanctioningBody, SanctioningBodyResponse } from 'models/viewModels';

class SanctioningBodyService {
  cachePromise: Promise<SanctioningBodyResponse> | undefined;

  private getCache(): Promise<SanctioningBodyResponse> {
    if (this.cachePromise) {
      return this.cachePromise;
    }

    this.cachePromise = sanctioningBodyApi.getSanctioningBodies().then((result) => result);

    return this.cachePromise;
  }

  async getSanctioningBodies(): Promise<SanctioningBody[]> {
    const cache = await this.getCache();
    return cache.sanctioningBodiesList;
  }

  async getSeries(sanctioningBodyId: string) {
    const cache = await this.getCache();
    const sanctioningBody = cache.sanctioningBodiesList.find(
      (sanctioningBody) => sanctioningBody.sanctioningBodyId === sanctioningBodyId
    );
    return sanctioningBody
      ? cache.sanctioningBodySeriesList.filter((series) =>
          sanctioningBody.sanctioningBodySeriesIdsList.includes(series.seriesId)
        )
      : [];
  }
}

export const sanctioningBodyService = new SanctioningBodyService();
